import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { baseUniDriverFactory } from '../../testkitUtils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { ImageInfo } from '@wix/image';

// TODO: Remove the related methods if everything is okay with the design partners
const deprecatedMethod = () => {
  throw new Error(
    `This method isn't implemented anymore. Please contact us in case you need it.`,
  );
};

export interface WowImageDriver extends BaseUniDriver {
  getSrc(): Promise<string>;
  getAlt(): Promise<string>;
  getAspectRatio(): Promise<string>;
  getSourceWidth(): Promise<string>;
  getSourceHeight(): Promise<string>;
  getResize(): Promise<string>;
  getShouldUseLQIP(): Promise<string>;
  getIsInFirstFold(): Promise<string>;
  getIsSEOBot(): Promise<string>;
  isLoaded(): Promise<boolean>;
  isError(): Promise<boolean>;
  getId(): Promise<string>;
  getEncoding(): Promise<ImageInfo['encoding']>;
}

export const wowImageDriverFactory = (base: UniDriver): WowImageDriver => {
  const getImageInfo = async (): Promise<ImageInfo> =>
    JSON.parse(await base.$('wow-image').attr('data-image-info'));
  return {
    ...baseUniDriverFactory(base),
    getSrc: async () => {
      return (await getImageInfo()).imageData.uri;
    },
    getAlt: () => base.$('img').attr('alt'),
    getAspectRatio: () => base.attr('data-aspect-ratio'),
    getSourceWidth: () => base.attr('data-source-width'),
    getSourceHeight: () => base.attr('data-source-height'),
    getResize: () => base.attr('data-resize'),
    getShouldUseLQIP: () => base.attr('data-use-lqip'),
    getIsInFirstFold: () => base.attr('data-first-fold'),
    getIsSEOBot: () => base.attr('data-is-seo-bot'),
    getId: () => base.attr('id'),
    getEncoding: async () => (await getImageInfo()).encoding,
    isLoaded: deprecatedMethod,
    isError: deprecatedMethod,
  };
};
